import React from 'react'

function celebrations() {
  return (
    <div>
      <h1>Celebrations</h1>
    </div>
  )
}

export default celebrations
